import React, { useState, useEffect } from 'react'
import clsx from 'clsx'
import { CustomLink } from '@/components/atoms/CustomLink/CustomLink'

type AccordionProps = {
  title: CustomLinkTypes[]
  links: CustomLinkTypes[]
}

export function Accordion({ title = [], links = [] }: AccordionProps) {
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    const path = window.location.pathname.slice(0, -1)
    const isCurrentPath = title[0].link_url?.cached_url?.includes(path)

    setIsOpen(isCurrentPath)
  }, [])

  const toggleOpen = () => setIsOpen((prev) => !prev)

  return (
    <li className="mb-24">
      <div className="text-left flex items-start">
        <button type="button" aria-labelledby="open-accordion" className="mr-16" onClick={toggleOpen}>
          <i className={clsx('text-primary-600', isOpen ? 'fa fa-chevron-up' : 'fa fa-chevron-down')} />
        </button>
        {title.length && (
          <button type="button" className="text-primary-600 font-bold text-bodyL font-mulish text-left">
            <CustomLink {...title[0]}>{title[0]?.text}</CustomLink>
          </button>
        )}
      </div>
      {isOpen && (
        <div className="mt-24">
          <ul className="block pl-48 list-disc">
            {links?.map((item) => (
              <li key={item._uid} className="mb-16">
                <CustomLink
                  className="text-black-dark text-bodyM capitalize font-mulish"
                  activeClassName="text-primary-500 underline font-semibold"
                  key={item._uid}
                  {...item}
                >
                  {item.text}
                </CustomLink>
              </li>
            ))}
          </ul>
        </div>
      )}
    </li>
  )
}
